export default "__VITE_ASSET__BBszKGJo__"